import React from "react";
import "./Education.css";
import Navbar from "../components/Navbar";

const Aec = () => {
  return (
    <>
      <Navbar />
      <div className="energyInfra-container">
        <div className="energyInfra-content">
          <p className="para">Industries / Architecture, Engineering & Construction (AEC)</p>
          <h2>Architecture, Engineering & Construction (AEC)</h2>
          <p className="subtitle1">
            Building Smarter, Safer & Faster with XR-Driven Spatial Experiences
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we empower architects, civil engineers, and construction firms to visualize, validate, and coordinate complex AEC projects in immersive environments. Our XR (AR/VR/MR) solutions improve design precision, stakeholder engagement, remote coordination, and safety across the entire lifecycle — from concept to construction.
          </p>

          <div className="energyInfra-grid">
            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Immersive Design Review & Virtual Walkthroughs</h4>
                <p>Visualize architectural spaces before they’re built.</p>
                <ul>
                  <li>Walk through unbuilt spaces in VR: homes, hospitals, airports, malls</li>
                  <li>Spot design clashes, scale issues, and accessibility flaws early</li>
                  <li>Multi-stakeholder reviews for faster approvals</li>
                </ul>
                <p><strong>Ideal for:</strong> Architecture firms, urban planners, real estate developers</p>
              </div>

              <div className="energyInfra-box">
                <h4>BIM + XR Integration</h4>
                <p>Transform static BIM models into interactive 3D experiences.</p>
                <ul>
                  <li>Support for Autodesk Revit, Navisworks, SketchUp, etc.</li>
                  <li>Layer-wise filtering, component inspection, and spatial annotation</li>
                  <li>Used for design validation, site logistics planning, and client presentations</li>
                </ul>
                <p><strong>Ideal for:</strong> Engineering consultants, civil contractors, project owners</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>XR for Construction Safety & Training</h4>
                <p>Train site workers on safety protocols and equipment handling using virtual simulations.</p>
                <ul>
                  <li>VR-based safety modules for crane operation, scaffolding, welding, and confined space entry</li>
                  <li>Replicates construction sites to practice emergency procedures</li>
                  <li>Real-time feedback and analytics on training performance</li>
                </ul>
                <p><strong>Ideal for:</strong> EPC companies, infrastructure developers, skill councils</p>
              </div>

              <div className="energyInfra-box">
                <h4>Digital Twin for Construction Monitoring</h4>
                <p>Create real-time 3D digital replicas of construction sites to monitor progress.</p>
                <ul>
                  <li>Visualize schedule vs actual status</li>
                  <li>Identify deviations, material usage, and safety compliance in spatial view</li>
                  <li>Combine drone/LiDAR input with IoT sensors</li>
                </ul>
                <p><strong>Ideal for:</strong> Infrastructure projects, government smart city missions</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Remote Client & Contractor Collaboration</h4>
                <p>Enable project teams across locations to review, co-edit, and make faster decisions together in VR.</p>
                <ul>
                  <li>Share 3D models, markups, issues in a shared spatial environment</li>
                  <li>Reduces rework, delays, and miscommunication</li>
                  <li>Saves travel cost and enables rapid iteration</li>
                </ul>
                <p><strong>Ideal for:</strong> Global design firms, PMCs, client stakeholders</p>
              </div>
            </div>
          </div>

          {/* Use Cases Table for AEC */}
          <div className="usecases1-section">
            <h3>Use Cases At a Glance</h3>
            <div className="usecases1-table">
              <div className="usecases1-row usecases1-header">
                <div>Use Case</div>
                <div>Application</div>
                <div>Benefit</div>
              </div>
              <div className="usecases1-row">
                <div>VR Walkthroughs</div>
                <div>Sales, design review</div>
                <div>Faster client buy-in</div>
              </div>
              <div className="usecases1-row">
                <div>BIM + XR</div>
                <div>Engineering coordination</div>
                <div>Reduce clashes, rework</div>
              </div>
              <div className="usecases1-row">
                <div>VR Safety Training</div>
                <div>Construction workers</div>
                <div>Improved safety compliance</div>
              </div>
              <div className="usecases1-row">
                <div>Digital Twin</div>
                <div>Project tracking</div>
                <div>Real-time status, early alerts</div>
              </div>
              <div className="usecases1-row">
                <div>Remote XR Reviews</div>
                <div>Global teams</div>
                <div>Reduced delays, better alignment</div>
              </div>
            </div>

            <div className="usecases1-cta">
              <h4>Build with Us</h4>
              <p>
                Whether you're designing a landmark or constructing critical infrastructure, SpatialCT can help you de-risk, accelerate, and elevate your project with immersive technologies.
              </p>
              <p>
                <b>Get in touch</b> to request a demo or collaborate on an XR proof-of-concept for your AEC needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Aec;
